import { PreLoginKcRealmVO } from '@repo/types'

export const discoverKeycloakRealm = async (email: string): Promise<PreLoginKcRealmVO[]> => {
  const url = new URL(`${import.meta.env.VITE_KC_DISCOVERY}/realms`)

  url.searchParams.append('email', email)
  url.searchParams.append('redirectUri', window.location.origin)
  url.searchParams.append('product', import.meta.env.VITE_KC_PRODUCT)

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      'x-api-key': import.meta.env.VITE_KC_DISCOVERY_API_KEY
    }
  })

  return response.json()
}
